module.exports = __webpack_public_path__ + "static/ai-2-sq-2476adc88683393dd70a6d29425df4d5.png";